import { Component, computed, inject, Input, OnInit } from '@angular/core';
import { AbsoluteMediaUriService } from '../../../../services/absolute-media-uri.service';
import { IMyBidDTO } from '../../../../models/IMyBidDTO';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
// import { InputSwitchModule } from 'primeng/inputswitch';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { CommonModule, NgFor } from '@angular/common';
import { SanitizeHtmlTextPipe } from '../../../../shared/pipes/sanitize-html-text.pipe';
import { RouterModule } from '@angular/router';
import { TimeLeftService } from '../../../../services/time-left.service';
import { MyBidsService } from '../../../../services/bidder-community/my-bids/my-bids.service';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../../services/authentication/auth.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { PopoverModule } from 'primeng/popover';
import { ApiService } from '../../../../services/api.service';
import { faCrown } from '@fortawesome/free-solid-svg-icons';




@Component({
  selector: 'app-my-bids-page',
  imports: [FontAwesomeModule,
    // InputSwitchModule,
    ToggleSwitch,
    SanitizeHtmlTextPipe,
    RouterModule,
    FormsModule,
    ButtonModule,
    SelectModule,
    CommonModule,
    PopoverModule],
  templateUrl: './my-bids-page.component.html',
  styleUrl: './my-bids-page.component.scss'
})
export class MyBidsPageComponent implements OnInit {

  @Input() myBids: IMyBidDTO[] = [];

  absoluteMediaUriService = inject(AbsoluteMediaUriService);
  protected readonly timeLeftService = inject(TimeLeftService);
  private readonly myBidsService = inject(MyBidsService);
  private readonly authService = inject(AuthService);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly apiService = inject(ApiService);


  creditCards = this.authService.creditCardSignal;
  isAuthenticated = this.oidcSecurityService.authenticated;
  auctionConfigSignal = this.apiService.auctionConfigSignal;

  faCrown = faCrown;

  selectedCard: number | null = null;

  cardOptions = computed(() => {
    const data = this.authService.creditCardSignal();
    if (!data) return [];

    return data.creditCards.map(card => ({
      label: `${card.type} ****${card.lastDigits}`,
      value: card.id
    }))
  });

  currency = computed(() => {
    const currency = this.auctionConfigSignal()?.currency || 'USD';
    return currency || 'USD'
  });

  faTrashCan = faTrashCan;

  ngOnInit(): void {

    //populate credit cards
    if (this.isAuthenticated().isAuthenticated && !this.authService.creditCardSignal()?.creditCards) {
      this.authService.getCreditCard().subscribe();
    }

  }

  trackById(index: number, item: IMyBidDTO): number {
    return item.itemId;
  }

  onPatchCoverTheFee(bidId: number, value: boolean, cardId: number) {

    this.myBidsService.patchCoverTheFee(bidId, value, cardId).subscribe({
      next: () => {
        const cards = this.creditCards();
        const newCard = cards?.creditCards.find(c => c.id === cardId);
        const index = this.myBids.findIndex(b => b.id === bidId);
        if (index !== -1 && newCard) {
          this.myBids[index].creditCard = { ...newCard };
        }
      },
      error: (error) => {
        console.error('Favorite error:', error);
      }
    });
  }

  onOpenPopover(event: Event, popover: any) {
    this.selectedCard = null;
    popover.toggle(event);
  }
}
